import React from 'react';
import Button from '@material-ui/core/Button';
import Layout from 'Layouts/Back';
import Link from 'Pure/Link';
import { front_urls, URL } from 'Shared/Routes';
import DirectBookingForm from 'Components/Forms/Models/Booking/DirectBookingForm';
function NewDirectBookingPage() {
  return /*#__PURE__*/React.createElement(Layout, {
    page_title: "Nouvelle r\xE9servation"
  }, /*#__PURE__*/React.createElement("div", {
    className: "o-content"
  }, /*#__PURE__*/React.createElement(Button, {
    component: Link,
    href: URL('AdminBookingsDashboard', front_urls),
    className: "u-margin-bottom-15"
  }, '<', " Retour aux r\xE9servations"), /*#__PURE__*/React.createElement(DirectBookingForm, null)));
}
;
export default NewDirectBookingPage;
